import request from '@/utils/request'

/**
 * 抖音达人列表
 * https://www.showdoc.com.cn/1003739271891029/10418522753207827
 */
export function fetchAccount(pvd = 'tikTok') {
    let url = '/api/selection_library/user/tik_tok/list'
    if (pvd === 'kuaishou') {
        url = '/api/selection_library/user/kuaishou/list'
    }
    return request({
        url: url,
        method: 'get'
    })
}


/**
 * 抖音达人删除
 * https://www.showdoc.com.cn/1003739271891029/10418541326578036
 */
export function deleteAccount(data, pvd = 'tikTok') {
    let url = '/api/selection_library/user/tik_tok/del'
    if (pvd === 'kuaishou') {
        url = '/api/selection_library/user/kuaishou/del'
    }
    return request({
        url,
        method: 'POST',
        data
    })
}
